import { initValidationMethods } from './macmillan.donation.validatorMethods.js';
import { handleHiddenAddressFields, submitFormWithSubmitterValue } from './validation.helpers.js';

/**
 * Intercepts WBCM form submission to handle multi-step form flow.
 * Ensures hidden address fields are revealed and validated for relevant steps
 * (UserAndEventDetails, Donate) but allows direct submission for PayIn step.
 */
$('.wbcmform').on('submit', function (e) {
    e.preventDefault();

    const submitter = e.originalEvent?.submitter;

    // Get current step from hidden field
    const step = $(this).find('input[name="CurrentStep"]').val();
    
    // PayIn/Consent steps don't require address validation
    if(step === 'PayIn' || step === 'Consent') {
        if($(this).valid()) {
            submitFormWithSubmitterValue(this, submitter);
        }
        return;
    }

    // Handle address field validation for steps that collect address data
    if(step === 'UserAndEventDetails' || step === 'Donate') {
       handleHiddenAddressFields(e, this);
    }
});

const initWbcmFormValidation = () => {
    $("form.wbcmform").validate({
        ignore: ":hidden",
        onkeyup: false,
        errorElement: "p",
        wrapper: 'div',
        errorClass: 'error messagebox js',
        errorPlacement: function (error, element, errorClass, validClass) {
            const errorId = element.attr('id') + '-error';
            error.attr('id', errorId);
            element.attr('aria-describedby', errorId);

            if (element.hasClass('taxPayerInput')) {
                error.appendTo(element.closest('.taxPayer--true').siblings('.taxPayer--false'));
            } else {
                error.appendTo(element.closest('div.fieldContainer'));
            }
            error.attr('role', 'alert');
        },
        highlight: function (element, errorClass, validClass) {
            $(element).closest('.fieldContainer').addClass('errorbox');

            if (element.classList.contains('taxPayerInput')) {
                $(element).closest('.giftaid').addClass('errorbox').find('.taxPayer').addClass('errorbox');
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            element.removeAttribute('aria-describedby');
            $(element).closest('.fieldContainer').removeClass('errorbox');

            if (element.classList.contains('taxPayerInput')) {
                $(element).closest('.giftaid').removeClass('errorbox').find('.taxPayer').removeClass('errorbox');
            }
        },
        messages: {
            "Donation.Payment.Amount": {
                required: "Please tell us the amount you want to donate.",
                number: "Please enter a valid amount you want to donate."
            },
            "Donation.Donor.Email": {
                required: "Please tell us your email address.",
                email: "Please enter a valid email address."
            },
            "Donation.Donor.Title": {
                required: "Please enter your title."
            },
            "Donation.Organisation.Title": {
                required: "Please enter your title."
            },
            "Donation.Donor.Address.PostalCode": {
                required: "Postcode is required.",
                postcode: "Postcode is invalid."
            },
            "Donation.Donor.Address.FirstLine": {
                required: "Please enter the first line of your address.",
                isAddressFormat: "Address line 1 accepts only letters, numbers, hyphens, apostrophes and spaces."
            },
            "Donation.Donor.Address.SecondLine": {
                isAddressFormat: "Address line 2 accepts only letters, numbers, hyphens, apostrophes and spaces."
            },
            "Donation.Donor.Address.PostalTown": {
                required: "Please enter your postal town.",
                isTownFormat: "Please enter letters, hyphens, apostrophes, full stops and spaces only."
            },
            "Donation.Donor.FirstName": {
                required: "Please tell us your first name.",
                isNameFormat: "First name accepts only accented letters, hyphens, apostrophes and spaces."
            },
            "Donation.Donor.LastName": {
                required: "Please tell us your last name.",
                isNameFormat: "Last name accepts only accented letters, hyphens, apostrophes and spaces."
            },
            "Donation.Organisation.Address.PostalCode": {
                required: "Postcode is required.",
                postcode: "Postcode is invalid."
            },
            "Donation.Organisation.Address.FirstLine": {
                required: "Please include first line of address.",
                isAddressFormat: "Address line 1 accepts only letters, numbers, hyphens, apostrophes and spaces."
            },
            "Donation.Organisation.Address.SecondLine": {
                isAddressFormat: "Address line 2 accepts only letters, numbers, hyphens, apostrophes and spaces."
            },
            "Donation.Organisation.Address.PostalTown": {
                required: "Please include postal town.",
                isTownFormat: "Please enter letters, hyphens, apostrophes, full stops and spaces only."
            },
            "Donation.Organisation.Firstname": {
                required: "Please enter first name.",
                isNameFormat: "First name accepts only accented letters, hyphens, apostrophes and spaces."
            },
            "Donation.Organisation.Lastname": {
                required: "Please enter last name.",
                isNameFormat: "Last name accepts only accented letters, hyphens, apostrophes and spaces."
            },
            "Donation.Donor.Phone.PhoneType": {
                required: "Please select a telephone type."
            },
            "Donation.Organisation.Phone.PhoneType": {
                required: "Please select a telephone type."
            },
            "Donation.Organisation.OrganisationType": {
                required: "Please enter the event address type."
            },
            "Donation.Organisation.Name": {
                organisationName: "Please specify the company/group/school name.",
                maxlength: "Company/Group/School name must be less than 50 characters."
            },
            "TaxPayer": {
                required: "Please choose whether you would like to add Gift Aid."
            },
        },

        rules: {
            "Donation.Donor.Email": {
                email: true
            },
            "Donation.Payment.Amount": {
                required: true,
                number: true,
                max: 99999999999999
            },
            "Donation.Donor.Title": {
                required: true
            },
            "Donation.Organisation.Title": {
                required: true
            },
            "Donation.Organisation.Name": {
                organisationName: true,
                maxlength: 50,
                consentRule: true
            },
            "Donation.Donor.Address.PostalCode": {
                required: true,
                postcode: true,
                consentRule: true
            },
            "Donation.Organisation.Address.PostalCode": {
                required: true,
                postcode: true,
                consentRule: true
            },
            "Donation.Donor.FirstName": {
                required: true,
                isNameFormat: true,
                consentRule: true
            },
            "Donation.Organisation.Firstname": {
                required: true,
                isNameFormat: true,
                consentRule: true
            },
            "Donation.Donor.LastName": {
                required: true,
                isNameFormat: true,
                consentRule: true
            },
            "Donation.Organisation.Lastname": {
                required: true,
                isNameFormat: true,
                consentRule: true
            },
            "Donation.Donor.Phone.Number": {
                consentRule: true
            },
            "Donation.Organisation.Phone.Number": {
                consentRule: true
            },
            "Donation.Donor.Address.FirstLine": {
                required: true,
                isAddressFormat: true,
                consentRule: true
            },
            "Donation.Donor.Address.SecondLine": {
                isAddressFormat: true,
                consentRule: true
            },
            "Donation.Donor.Address.PostalTown": {
                required: true,
                isTownFormat: true,
                consentRule: true
            },
            "Donation.Organisation.Address.FirstLine": {
                required: true,
                isAddressFormat: true,
                consentRule: true
            },
            "Donation.Organisation.Address.SecondLine": {
                isAddressFormat: true,
                consentRule: true
            },
            "Donation.Organisation.Address.PostalTown": {
                required: true,
                isTownFormat: true,
                consentRule: true
            },
            "Donation.Organisation.OrganisationType": {
                required: true
            },
            "TaxPayer": {
                required: true
            }
        }
    });
}

$(() => {
    initValidationMethods();
    initWbcmFormValidation();
});
